export const PPCData = {
  buttons: {
    defaultButtons: [{ text: 'Sign up', url: '/accounts/signup/' }],
    authenticatedButton: { text: 'Dashboard', url: '/dashboard/' },
  },
  chapters: [],
};
